import { render, staticRenderFns } from "./message.vue?vue&type=template&id=7a0a0074&scoped=true&lang=pug&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=7a0a0074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a0074",
  null
  
)

export default component.exports